import { createContext, useContext } from 'react';

const OpenGLRenderWindowContext = createContext(null);
const RenderWindowContext = createContext(null);
const RendererContext = createContext(null);
const FieldDataContext = createContext(null);
const DatasetContext = createContext(null);
const RepresentationContext = createContext(null);
const DownstreamContext = createContext(null);
const ShareDataSetContext = createContext(null);
const MultiViewRootContext = createContext(false);
const ViewContext = createContext(null);
function useViewContext() {
    const view = useContext(ViewContext);
    if (!view)
        throw new Error('No View context!');
    return view;
}
function useRenderWindowContext() {
    const rw = useContext(RenderWindowContext);
    if (!rw)
        throw new Error('No RenderWindow context!');
    return rw;
}
function useRendererContext() {
    const r = useContext(RendererContext);
    if (!r)
        throw new Error('No Renderer context!');
    return r;
}
function useFieldDataContext() {
    const fd = useContext(FieldDataContext);
    if (!fd)
        throw new Error('No FieldData context!');
    return fd;
}
function useDatasetContext() {
    const ds = useContext(DatasetContext);
    if (!ds)
        throw new Error('No Dataset context!');
    return ds;
}
function useRepresentationContext() {
    const rep = useContext(RepresentationContext);
    if (!rep)
        throw new Error('No Representation context!');
    return rep;
}
function useDownstreamContext() {
    const ds = useContext(DownstreamContext);
    if (!ds)
        throw new Error('No Downstream context!');
    return ds;
}
function useShareDataSetContext() {
    const share = useContext(ShareDataSetContext);
    if (!share)
        throw new Error('No ShareDataSet context!');
    return share;
}

export { DatasetContext, DownstreamContext, FieldDataContext, MultiViewRootContext, OpenGLRenderWindowContext, RenderWindowContext, RendererContext, RepresentationContext, ShareDataSetContext, ViewContext, useDatasetContext, useDownstreamContext, useFieldDataContext, useRenderWindowContext, useRendererContext, useRepresentationContext, useShareDataSetContext, useViewContext };
